module.exports = __webpack_public_path__ + "static/media/goblin_axeman.92b5a64a.svg";